import React from "react";
import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ show, label = false }) {
  if (!show) return null;
  return (
    <span data-testid="verified-badge" title="ID and Vedic certification verified by Pancham Dham" className="inline-flex items-center gap-1 text-[#1D6FE0] align-middle">
      <BadgeCheck className="w-5 h-5 fill-[#1D6FE0] text-white" />
      {label && <span className="text-xs font-semibold">Verified</span>}
    </span>
  );
}
